module.exports = __webpack_public_path__ + "static/media/pla_process.e1f61417.png";